import React from 'react';
import {
  PLATFORM_ICON_META,
  PLATFORM_ICON_PATHS,
} from './marketingPlatformIcons';
import './MarketingPlatformCell.css';

export const normalizeMarketingPlatformKey = (raw) => {
  const value = String(raw || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (!value) return null;
  if (value.includes('audience')) return 'audience';
  if (value.includes('facebook') || value === 'fb') return 'facebook';
  if (value.includes('instagram') || value === 'ig') return 'instagram';
  if (value.includes('messenger')) return 'messenger';
  if (value.includes('threads')) return 'threads';
  if (value.includes('whatsapp') || value === 'wa') return 'whatsapp';
  if (value.includes('linkedin')) return 'linkedin';
  if (value.includes('google')) return 'google';
  if (value.includes('meta')) return 'meta';
  if (PLATFORM_ICON_META[value]) return value;
  return null;
};

export const resolveRowPlatformKeys = (row, routePlatform) => {
  const fromApi = (Array.isArray(row?.platforms) ? row.platforms : [])
    .map((entry) => normalizeMarketingPlatformKey(entry))
    .filter(Boolean);
  const unique = [...new Set(fromApi)];
  if (unique.length) return unique;

  const channel = normalizeMarketingPlatformKey(row?.platform || routePlatform);
  return channel ? [channel] : [];
};

function PlatformIcon({ platformKey }) {
  const meta = PLATFORM_ICON_META[platformKey];
  const icon = PLATFORM_ICON_PATHS[platformKey];
  if (!meta || !icon) return null;

  const viewBox = icon.viewBox || '0 0 24 24';
  const paths = icon.paths || (icon.d ? [{ d: icon.d, fill: 'currentColor' }] : []);

  return (
    <span
      className={`marketing-platform-icon ${meta.className}`}
      style={{ '--platform-brand-color': meta.color }}
      role="img"
      aria-label={meta.label}
      title={meta.label}
    >
      <svg viewBox={viewBox} aria-hidden focusable="false">
        {paths.map((segment, index) => (
          <path key={index} d={segment.d} fill={segment.fill} />
        ))}
      </svg>
    </span>
  );
}

export function MarketingPlatformTd({ row, routePlatform }) {
  return (
    <td className="marketing-platform-col">
      <MarketingPlatformCell row={row} routePlatform={routePlatform} />
    </td>
  );
}

export default function MarketingPlatformCell({ row, routePlatform }) {
  const keys = resolveRowPlatformKeys(row, routePlatform);

  if (!keys.length) {
    return <span className="marketing-platform-cell marketing-platform-cell--empty">—</span>;
  }

  const labels = keys.map((k) => PLATFORM_ICON_META[k]?.label).filter(Boolean);

  return (
    <div className="marketing-platform-cell" title={labels.join(', ')}>
      {keys.map((key) => (
        <PlatformIcon key={key} platformKey={key} />
      ))}
    </div>
  );
}
